export default {
      id: "play-status-usage",
      viewBox: "0 0 8 10",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#play-status-usage",
      toString: function () {
        return this.url;
      }
    }